import React from 'react';

import AdditionalScoresAdapter from './adapters/MatchScoresAdapter';
import * as MainScoreAdapter from 'shared/adapters/MatchScoresAdapter';

export default class MatchStats extends React.Component {
    static propTypes = {
        match: React.PropTypes.object,
        matchScores: React.PropTypes.object,
        mainScoreElement: React.PropTypes.func.isRequired,
        additionalScoresElement: React.PropTypes.func.isRequired
    };

    static renderAdditionalScores(additionalScores, props) {
        const scoreProps = {
            additionalScores,
            additionalScoreElement: props.additionalScoreElement
        };

        const AdditionalScoresElement = props.additionalScoresElement;

        return (<AdditionalScoresElement {...scoreProps}/>);
    }

    static renderMainScore(scoreId, props) {
        const scoreProps = {
            scoreId
        };

        const MainScoreElement = props.mainScoreElement;

        return (<MainScoreElement key={scoreId} {...scoreProps}/>);
    }

    render() {
        const match = this.props.match;
        const scores = this.props.matchScores;

        if (match === undefined) {
            return false;
        }

        const sportId = match.get('realSportId');

        const mainScoreId = MainScoreAdapter.getMainScore(scores);
        const additionalScores = AdditionalScoresAdapter.getAdditionalScores(sportId, scores);

        if (mainScoreId === null && additionalScores.length === 0) {
            return false;
        }

        if (mainScoreId === null) {
            return (<div className="event-stats">
                        {MatchStats.renderAdditionalScores(additionalScores, this.props)}
                    </div>);
        }

        return (<div className="event-stats">
                    {MatchStats.renderMainScore(mainScoreId, this.props)}
                    {MatchStats.renderAdditionalScores(additionalScores, this.props)}
                </div>);
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/MatchStats.jsx